export interface ProfileIdentifier {
  shortId: string | null;
  email: string | null;
  domain: string | null;
}

import { ParamMap } from '@angular/router';

export function extractProfileIdentifier(routeParams: ParamMap): ProfileIdentifier {
  return {
    shortId: routeParams.get('shortId'),
    email: routeParams.get('email'),
    domain: routeParams.get('domain'),
  };
}

export function isPublicProfileRoute(url: string): boolean {
  return url.includes('/s/') || url.includes('/e/') || url.includes('/d/');
}
